import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { terms_condition } from "../network/Network";
import { norecord } from "../Constant/Index";

const TermsofService = () => {
  const [terms, setTerms] = useState();

  useEffect(() => {
    terms_condition().then((res) => {
      setTerms(res?.data);
    });
  }, []);

  return (
    <>
      <Header />
      <PageHeader pagename="Terms of Service" />
      <section className="services-pages pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {terms?.length > 0 ? (
                <p
                  className="primary-regular-font extra-color-5 level-7 mt-3"
                  dangerouslySetInnerHTML={{ __html: terms }}
                />
              ) : (
                <div className="no_recod_img text-center">
                  <img
                    src={norecord}
                    alt="No records available"
                    className="img-fluid text-center "
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default TermsofService;
